import { render, staticRenderFns } from "./schedule_rematch_competition.vue?vue&type=template&id=612046b5&scoped=true"
import script from "./schedule_rematch_competition.vue?vue&type=script&lang=js"
export * from "./schedule_rematch_competition.vue?vue&type=script&lang=js"
import style0 from "./schedule_rematch_competition.vue?vue&type=style&index=0&id=612046b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612046b5",
  null
  
)

export default component.exports